<div style="display: flex;">
    <p style="padding-top: 10px">{{'SETTINGS.LANGUAGE' | transloco }} </p> <languages></languages>
</div>